import React from 'react';
import classnames from 'classnames';

const Container = ({ children, className }) => {
	const cls = classnames(
		'bg-white dark:bg-neutral-800 rounded-lg transition-colors',
		className
	);

	return (
		<div className={cls}>{children}</div>
	);
};

export default Container;